import { jsx as m } from "react/jsx-runtime";
import { forwardRef as c, useRef as L, useMemo as S } from "react";
import { Virtuoso as E } from "react-virtuoso";
import { useMergeRefs as a } from "@chakra-ui/react";
import { SavedListItemEditSkeleton as w, SavedListItemEdit as x } from "./SavedListItemEdit.es.js";
const b = c(
  ({ list: s, creators: n, isLoading: f, onCreatorChange: d, styles: g, query: i, onRemove: l }, h) => {
    const p = L(null), u = a(h, p), v = (t, o) => {
      const e = [...n].map(
        (r) => r.id === o.id ? o : r
      );
      d(t, o, e);
    }, R = S(() => i ? n.filter(({ name: t, searchable: o = [] }) => {
      const e = new RegExp(i, "gi");
      return t.match(e) || o.toString().match(e);
    }) : n, [n, i]);
    return /* @__PURE__ */ m(
      E,
      {
        data: R,
        ref: u,
        style: { height: 300, overflowX: "hidden", ...g },
        totalCount: n.length,
        itemContent: (t, o) => {
          const e = o.onRemove ?? l;
          return f ? /* @__PURE__ */ m(w, { marginTop: t ? 6 : 0 }) : /* @__PURE__ */ m(
            x,
            {
              creator: o,
              isLoading: o.isLoading,
              list: s,
              marginTop: t ? 6 : 0,
              onNoteChange: v,
              onRemove: e ? () => e(o) : void 0
            },
            o.id
          );
        }
      }
    );
  }
);
export {
  b as SavedListEdit
};
//# sourceMappingURL=SavedListEdit.es.js.map
